<template>
  <div class="column items-center">
    <p class="q-ma-none">{{ data.origin?data.origin.city:'' }}</p>
    <p class="q-ma-none">{{ data.origin?data.origin.state:'' }}</p>
    <p class="q-ma-none">{{ data.origin?data.origin.zipcode:'' }}</p>
  </div>
</template>

<script>
export default {
  name: 'AppQuoteOrigin',
  props: ['data']
};
</script>
